import { render } from "./change-password.vue?vue&type=template&id=3708b109&ts=true"
import script from "./change-password.vue?vue&type=script&lang=ts"
export * from "./change-password.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__